import { times } from 'lodash/fp'

export const getPaginatedPathSuffix = (pageNumber: number) =>
  pageNumber > 1 ? `page/${pageNumber}/` : ''

interface PaginateConfig {
  itemCount: number
  itemsPerPage?: number
}

export type PaginateIterator = (args: {
  numberOfPages: number
  pageNumber: number
  pathSuffix: string
  limit: number
  skip: number
}) => unknown

export const paginate = (
  { itemCount, itemsPerPage = 12 }: PaginateConfig,
  iterator: PaginateIterator
) => {
  const numberOfPages = Math.ceil(itemCount / itemsPerPage) || 1

  times((i) => {
    const pageNumber = i + 1

    iterator({
      numberOfPages,
      pageNumber,
      pathSuffix: getPaginatedPathSuffix(pageNumber),
      limit: itemsPerPage,
      skip: i * itemsPerPage,
    })
  }, numberOfPages)
}
